import { Injectable } from '@angular/core';
import { Theme } from '../enums/theme.enum';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    setTheme(theme: Theme): void {
        switch (theme) {
            case Theme.system:
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    this.loadDarkTheme();
                    document.body.classList.add('dark-theme');
                } else {
                    document.body.classList.remove('dark-theme');
                    document.body.style.backgroundColor = '#f1f3f4';
                }
                localStorage.setItem('darkTheme', Theme.system.toString());
                break;
            case Theme.dark:
                this.loadDarkTheme();
                document.body.classList.add('dark-theme');
                localStorage.setItem('darkTheme', Theme.dark.toString());
                break;
            default:
            case Theme.light:
                document.body.classList.remove('dark-theme');
                document.body.style.backgroundColor = '#f1f3f4';
                localStorage.setItem('darkTheme', Theme.light.toString());
                break;
        }
    }

    private loadDarkTheme(): void {
        const themeCSSID = 'themeCSS';

        if (!document.getElementById(themeCSSID)) {
            const head = document.getElementsByTagName('head')[0];
            const link = document.createElement('link');
            link.id = themeCSSID;
            link.rel = 'stylesheet';
            link.href = 'dark-theme.css';
            head.appendChild(link);
        }
    }
}
